const mcVisFromWindow = typeof window !== 'undefined' ? window.s?.marketingCloudVisitorID : null;
export const MARKETING_CLOUD_VISITOR_ID_DEFAULT = '12345-Homepage';
const thdCustomer = typeof window !== 'undefined' ? window.THDCustomer?.default : null;

const CUSTOMER_TYPES = {
  GUEST: 'b2c-guest',
  B2C: 'b2c',
  B2B: 'b2b',
  EPROCUREMENT: 'eprocurement-b2b',
  EXCHANGE: 'exchange-b2b'
};

function getSvocId() {
  return thdCustomer?.svocID || null;
}

function getUserId() {
  return thdCustomer?.userID || null;
}

function _convertCrumbsToJson(crumbs) {
  let propName = null;
  // eslint-disable-next-line id-length
  const crumbData = crumbs.reduce(function _reduce(a, b) {
    if (propName) {
      // eslint-disable-next-line no-param-reassign
      a[propName] = b;
      propName = null;
    } else {
      propName = b;
    }
    return a;
  }, {});

  return crumbData;
}

function getMarketingCloudVisitorIDFromCookie() {
  try {
    const theCookie = window?.cookieUtils?.readBrowserCookie(
      'AMCV_F6421253512D2C100A490D45%40AdobeOrg',
    );
    let crumbs = theCookie ? theCookie.split('|') : [];
    if (crumbs.length > 1) {
      crumbs.shift(); // custom for adobe kill first value
    }
    const crumbData = _convertCrumbsToJson(crumbs);
    return (crumbData && crumbData.MCMID) || '';
    // eslint-disable-next-line id-length
  } catch (e) {
    return null;
  }
}

function getMarketingCloudVisitorID() {
  return (
    thdCustomer?.mcvisID
    || getMarketingCloudVisitorIDFromCookie()
    || mcVisFromWindow
    || MARKETING_CLOUD_VISITOR_ID_DEFAULT
  );
}

export const getPersonalizedDealsUserId = (customerType) => {
  return customerType === CUSTOMER_TYPES.B2B
    ? getSvocId() + '_' + getUserId()
    : getMarketingCloudVisitorID();
};